<template>
    <page-layout>
        <ig-connection-faq />
        <template #footer>
            <proposal-step-footer
                :use-exit-modal="false"
                :is-next-disabled="true"
                :hide-steps="true"
                @go-previous-step="handlePreviousStep"
            />
        </template>
    </page-layout>
</template>

<script>
    import PageLayout from '../../layouts/PageLayout.vue';
    import ProposalStepFooter from './partials/ProposalStepFooter.vue';
    import IgConnectionFaq from '../networks/partials/IgConnectionFaq.vue';
    import { INSTAGRAM_ID } from '../../../constants/networks';

    export default {
        name: 'ProposalNetworksFaqView',
        components: {
            IgConnectionFaq,
            ProposalStepFooter,
            PageLayout
        },
        methods: {
            handlePreviousStep() {
                this.$router.push({
                    name: 'v2.campaign.proposal.networks.network',

                    query: {
                        networkId: INSTAGRAM_ID
                    }
                });
            }
        }
    };
</script>
